module.exports = __webpack_public_path__ + "static/media/20180608_162515.9cba3cb3.jpg";